import { AnyAction } from "redux";
import { TournamentInterface } from "../types";

export const requested = (state: TournamentInterface): TournamentInterface => ({
  ...state,
  requestStates: {
    ...state.requestStates,
    matchByTournament: { failed: false, requesting: true, success: false },
  },
});

export const success = (
  state: TournamentInterface,
  action: AnyAction
): TournamentInterface => ({
  ...state,
  matchByTournament: [ 
    ...(state.matchByTournament || []),
    ...action.matchByTournament
  ],
  matchesPage: action.page,
  isLastMatchesPage: action.matchByTournament.length < 20,
  requestStates: {
    ...state.requestStates,
    matchByTournament: { failed: false, requesting: false, success: true },
  },
});

export const failed = (
  state: TournamentInterface,
  action: AnyAction
): TournamentInterface => ({
  ...state,
  requestStates: {
    ...state.requestStates,
    matchByTournament: {
      failed: action.error,
      requesting: false,
      success: false,
    },
  },
});

export const clear = (state: TournamentInterface): TournamentInterface => ({
  ...state,
  matchByTournament: null,
  matchesPage: 1,
  isLastMatchesPage: false,
  requestStates: {
    ...state.requestStates,
    matchByTournament: {
      failed: false,
      requesting: false,
      success: false,
    },
  },
});
